import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CompanyDto } from 'src/app/data-transfer/entities/doc-entities/company-dto';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';

export interface CreateDocDialogData {
  manufacturers: CompanyDto[];
  representatives: CompanyDto[];
}

@Component({
  selector: 'app-create-doc-dialog',
  templateUrl: './create-doc-dialog.component.html',
  styleUrl: './create-doc-dialog.component.scss',
})
export class CreateDocDialogComponent {
  readonly manufacturers: CompanyDto[];
  readonly representatives: CompanyDto[];

  form: FormGroup<{
    manufacturerId: FormControl<number | null>;
    representativeId: FormControl<number | null>;
    hasRepresentative: FormControl<boolean>;
  }>;

  constructor(
    private dialogRef: MatDialogRef<CreateDocDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: CreateDocDialogData,
    private coreDataService: CoreDataUpdateService
  ) {
    this.manufacturers = data.manufacturers;
    this.representatives = data.representatives;
    this.form = this.fb.group({
      manufacturerId: new FormControl<number | null>(data.manufacturers[0]?.companyProfileId ?? null),
      representativeId: new FormControl<number | null>(data.representatives[0]?.companyProfileId ?? null),
      hasRepresentative: new FormControl<boolean>(false, { nonNullable: true }),
    });
  }

  getCountryName(futureId: string | null): string {
    if (!futureId) return '';
    return this.coreDataService.allCountriesMap.get(futureId)?.name ?? '';
  }

  get selectedManufacturer(): CompanyDto | undefined {
    return this.manufacturers.find(c => c.companyProfileId === this.form.value.manufacturerId);
  }

  get selectedRepresentative(): CompanyDto | undefined {
    return this.representatives.find(c => c.companyProfileId === this.form.value.representativeId);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onContinue(): void {
    const value = this.form.value;
    this.dialogRef.close({
      confirmed: true,
      manufacturerId: value.manufacturerId,
      authorizedRepresentativeId: value.hasRepresentative ? value.representativeId : null,
    });
  }
}
